import { CreateClient } from 'utils/apiClient';

export class UploadAPI extends CreateClient {
  constructor (runtimeConfig) {
    // Authentication handled via cookies sent to Lambda authorizer at gateway
    
    super({
      baseUrl: runtimeConfig.REACT_APP_UPLOAD_API_BASE_URL,
      showLog: process.env.NODE_ENV === 'development'
    })
    this.http.interceptors.request.use(config => {
      return config
    })
    this.http.interceptors.response.use(
      response => {
        // Handle API Gateway responses that might return stringified JSON
        let responseData = response.data;
        if (typeof responseData === 'string') {
          try {
            responseData = JSON.parse(responseData);
          } catch (e) {
            // Failed to parse, return as-is
          }
        }
        return responseData;
      },
      error => Promise.reject(error)
    )
  }
  static apiInstance = null;
  static CreateInstance(runtimeConfig) {
    this.apiInstance = new UploadAPI(runtimeConfig);
  }

  static GetInstance(){
    return this.apiInstance;
  }
}

//export default UploadAPI
